import "./BottomNav.css";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useAuth } from "../context/AuthContext";

function BottomNav({ setPage, currentPage }) {
  const [userPlan, setUserPlan] = useState(null);
  const [allowedPages, setAllowedPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [planPermissions, setPlanPermissions] = useState({});
  const { isAdmin } = useAuth();
  const [userData, setUserData] = useState(null);
  const [userId, setUserId] = useState(null);

  // Plan permission mapping (fallback if API fails)
  // const defaultPermissions = {
  //   'visitor': {
  //     allowedPages: ['MarineTerminal', 'PipelineReceiving', 'TruckOffloading', 'CrudeTank1', 'CrudeTank2'],
  //     planName: 'Visitor Level (Free)'
  //   },
  //   'operator': {
  //     allowedPages: ['MarineTerminal', 'PipelineReceiving', 'TruckOffloading', 'CrudeTank1', 'CrudeTank2',
  //       'BlendingSystem', 'DayTank', 'SlopTank', 'PigLauncher', 'PigReceiver',
  //       'PreHeatTrain1', 'PreHeatTrain2', 'Desalter1', 'Desalter2'],
  //     planName: 'Operator Training Package'
  //   },
  //   'engineer': {
  //     allowedPages: ['MarineTerminal', 'PipelineReceiving', 'TruckOffloading', 'CrudeTank1', 'CrudeTank2',
  //       'BlendingSystem', 'DayTank', 'SlopTank', 'PigLauncher', 'PigReceiver',
  //       'PreHeatTrain1', 'PreHeatTrain2', 'Desalter1', 'Desalter2', 'PostDesalterHEX1',
  //       'PostDesalterHEX2', 'PreFlashTower', 'PFRefluxCond1', 'PFRefluxCond2',
  //       'FurnacePreHeat', 'Furnace', 'MainFractionationTowers', 'MainFractionationTowers2',
  //       'ProductStripper', 'T102RefluxCond', 'NaphthaReflux', 'SurgeTank'],
  //     planName: 'Process Engineer Suite'
  //   },
  //   'classroom': {
  //     allowedPages: 'all', // All pages accessible
  //     planName: 'Classroom'
  //   },
  //   'admin': {
  //     allowedPages: 'all', // All pages accessible
  //     planName: 'Administrator'
  //   }
  // };


  // const getUserData = () => {
  //   try {
  //     const storedData = localStorage.getItem('dcs_simulator_user_data');
  //     if (!storedData) return null;

  //     const parsed = JSON.parse(storedData);
  //     return parsed?.userData || parsed; // Handle both formats
  //   } catch (e) {
  //     console.error('Error parsing user data:', e);
  //     return null;
  //   }
  // };

  useEffect(() => { 
    console.log("getting user data")
  }, []);


  // Fetch user plan and permissions
  useEffect(() => {
    const fetchUserPlan = async () => {
      // 1. Check localStorage first

      const localStore = localStorage.getItem('user_plan_permissions');
      const cachedData = JSON.parse(localStore);

      if (cachedData?.allowedPages) {
        
        try {
          const parsed = cachedData;
          // Check if cache is still valid (e.g., not older than 1 hour)
          const cacheAge = Date.now() - parsed.timestamp;
          if (cacheAge < 3600000) { // 1 hour
            setUserPlan(parsed.plan);
            setAllowedPages(parsed.allowedPages);
            setPlanPermissions(parsed);
            setLoading(false);
            return;
          } else {
            console.log('🔄 Cache expired, fetching fresh data');
            localStorage.removeItem('user_plan_permissions');
          }
        } catch (error) {
          console.error('Error parsing cached data:', error);
          localStorage.removeItem('user_plan_permissions');
        }
      }

      

      // 2. If no cache or cache expired, fetch from backend
      try {
        const user_plan = cachedData.plan;
        // Get user's plan from userData or localStorage
        const userPlanFromData =
          user_plan ||
          'visitor';

        if (isAdmin) {

          // ✅ FIX 2: Get token and user data
          let token = localStorage.getItem('token');
          //const user = await getUserData();

          //console.log("getting user data", user);



          if (token && !isTokenExpired(token)) {
            // ✅ Token is valid
            console.log('Token is still valid');
          } else {
            // ❌ Token expired or missing
            console.log('Token expired or invalid');
            localStorage.removeItem('token');
            window.location.reload();
            // Redirect to login
          }


          try {
            const response = await fetch(`https://api.nktechhub.com/api/refinery/admin-plan-permissions?plan=${userPlanFromData}`, {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${token}`, // ✅ FIX: Uncommented!
                'Content-Type': 'application/json'
              }
            });

            let permissions;
            if (response.ok) {
              permissions = await response.json();
              cachedData.plan = permissions.plan;
              cachedData.allowedPages = permissions.allowedPages;
              cachedData.planName = permissions.planName;
              cachedData.timestamp = Date.now();
              localStorage.setItem('user_plan_permissions', JSON.stringify(permissions));
            } else {
              // Fallback to default permissions
              console.warn('⚠️ Backend fetch failed, using default permissions');
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch plan permissions. Please try again later.',
                confirmButtonText: 'OK'
              });
              return;
            }
            // Set permissions
            setUserPlan(permissions.plan);
            setAllowedPages(permissions.allowedPages);
            setPlanPermissions(permissions);
          } catch (error) {
            console.error('❌ Error fetching plan permissions:', error);
            // Display error message
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to fetch plan permissions. Please try again later Admin.',
              confirmButtonText: 'OK'
            });
          }
          return;
        }


        // Try to fetch from backend
        // getting for other users and not admin
        const response = await fetch(`https://api.nktechhub.com/api/refinery/plan-permissions?plan=${userPlanFromData}&email=${userData.userData.email}`, {
          credentials: 'include'
        });

        let permissions;
        if (response.ok) {
          permissions = await response.json();
          cachedData.plan = permissions.plan;
          cachedData.allowedPages = permissions.allowedPages;
          cachedData.planName = permissions.planName;
          cachedData.timestamp = Date.now();
          localStorage.setItem('user_plan_permissions', JSON.stringify(permissions));
          
        } else {
          // Fallback to default permissions
          console.warn('⚠️ Backend fetch failed, using default permissions');
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to fetch plan permissions. Please try again later.',
            confirmButtonText: 'OK'
          });
          return;
        }

        // Set permissions
        setUserPlan(permissions.plan);
        setAllowedPages(permissions.allowedPages);
        setPlanPermissions(permissions);


        localStorage.setItem('user_plan_permissions', JSON.stringify(cachedData));


      } catch (error) {
        console.error('❌ Error fetching plan permissions:', error);
        // display error message
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to fetch plan permissions. Please try again later.',
          confirmButtonText: 'OK'
        });

      } finally {
        setLoading(false);
      }
    };

    fetchUserPlan();
  }, [userData]);


      const getUserData = async () => {
        let token = localStorage.getItem('token');
        if (token) {
          try {
            const userInfo = await fetch(`https://api.nktechhub.com/user/v1/get-data`, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            if (!userInfo.ok) {
              throw new Error('Failed to get user data');
            }
  
            const parsedData = await userInfo.json();
            setUserId(parsedData.user.id);
            setUserData(parsedData.user);
  
            return parsedData.user;
          } catch (error) {
            console.error('Error parsing localStorage data:', error);
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to fetch user data. Please try again later.',
            confirmButtonText: 'OK'
          });
        }
  
        
      };


  const isTokenExpired = (token) => {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000; // Convert to milliseconds
      return Date.now() >= exp;
    } catch (e) {
      return true; // If can't parse, assume expired
    }
  };



  

  // Check if a page is accessible
  const isPageAccessible = (page) => {
    if (loading) return false;

    // If 'all' pages are allowed (classroom or admin)
    if (allowedPages === 'all') return true;

    // Check if page is in allowed list
    return allowedPages.includes(page);
  };

  /* ================= ROW 1 ================= */
  const row1 = [
    { page: "MarineTerminal", name: "Marine Import" },
    { page: "PipelineReceiving", name: "Pipeline Import" },
    { page: "TruckOffloading", name: "Truck Offloading" },
    { page: "CrudeTank1", name: "Crude Tank 1" },
    { page: "CrudeTank2", name: "Crude Tank 2" },
    { page: "BlendingSystem", name: "Blending" },
    { page: "DayTank", name: "Day Tanks" },
    { page: "SlopTank", name: "Slop Tank" },
    { page: "PigLauncher", name: "Pig Launcher" },
    { page: "PigReceiver", name: "Pig Receiver" },
    { page: "PreHeatTrain1", name: "Preheat Train 1" },
    { page: "PreHeatTrain2", name: "Preheat Train 2" },
    { page: "Desalter1", name: "Desalter1" },
  ];

  /* ================= ROW 2 ================= */
  const row2 = [
    { page: "Desalter2", name: "Desalter2" },
    { page: "PostDesalterHEX1", name: "Post-Desalter HEX 1" },
    { page: "PostDesalterHEX2", name: "Post-Desalter HEX 2" },
    { page: "PreFlashTower", name: "Pre-Flash Tower" },
    { page: "PFRefluxCond1", name: "P-F Reflux Cond1" },
    { page: "PFRefluxCond2", name: "P-F Reflux Cond2" },
    { page: "FurnacePreHeat", name: "Furnace Preheat" },
    { page: "Furnace", name: "Furnace (F-101)" },
    { page: "MainFractionationTowers", name: "TopFrac" },
    { page: "MainFractionationTowers2", name: "BottomFrac" },
    { page: "ProductStripper", name: "Stripper" },
    { page: "T102RefluxCond", name: "T-102 Reflux Cond" },
    { page: "NaphthaReflux", name: "T-102 Naphtha Reflux" },
    { page: "SurgeTank", name: "Surge Tank" },
    { page: "StabilizationTower", name: "Stabilizer" },
    { page: "StabilizationReflux", name: "Stab Reflux" },
    { page: "CorrosionDosing", name: "Corrosion Dosing" },
    { page: "FuelGasSystem", name: "Fuel Gas" },
    { page: "DieselCooler", name: "Diesel Cooler" },
    { page: "Residue", name: "Residue" },
    { page: "Naphtha", name: "Naphtha" },
    { page: "LPG", name: "LPG" },
    { page: "Diesel", name: "Diesel" },
    { page: "Kerosene", name: "Kerosene" },
    { page: "LoadingGantry", name: "Loading Gantry" },
    { page: "Desalination", name: "Desalination" },
    { page: "Flare", name: "Flare" },
    { page: "EconometricDashboard", name: "NKRBIC" },
  ];

  /* ================= RENDER ROW ================= */
  const renderRow = (row) => (
    <div className="nav-row">
      {row.map((item) => {
        const accessible = isPageAccessible(item.page);

        return (
          <button
            key={item.page}
            onClick={() => {
              if (accessible) {
                setPage(item.page);
              } else {
                // Show upgrade prompt
                alert(`🔒 The "${item.name}" page is not available on your current plan. Please upgrade to access this feature.`);
              }
            }}
            className={
              currentPage === item.page && accessible
                ? "nav-link active"
                : "nav-link"
            }
            style={{
              opacity: accessible ? 1 : 0.5,
              cursor: accessible ? 'pointer' : 'not-allowed',
              position: 'relative'
            }}
            disabled={!accessible}
          >
            {item.name}
            {!accessible && (
              <span
                style={{
                  marginLeft: '4px',
                  fontSize: '10px',
                  color: '#ff6b6b'
                }}
              >
                🔒
              </span>
            )}
          </button>
        );
      })}
    </div>
  );

  // Show loading state
  if (loading) {
    return (
      <div className="bottom-nav" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        minHeight: '100px'
      }}>
        <span style={{ color: '#8899aa' }}>Loading permissions...</span>
      </div>
    );
  }

  return (
    <div className="bottom-nav">
      <div style={{
        padding: '2px 4px',
        color: '#8899aa',
        fontSize: '12px',
        textAlign: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.05)',
        marginBottom: '2px'
      }}>
        {/* <span>Plan: {planPermissions.planName || userPlan || 'Unknown'} </span>
        <span style={{ color: '#00ff88' }}>
          {allowedPages === 'all' ? '🌐 Full Access' : `📄 ${allowedPages?.length || 0} pages accessible`}
        </span> */}
      </div>
      {renderRow(row1)}
      {renderRow(row2)}
    </div>
  );
}

export default BottomNav;